import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { environment } from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class RestService {

    PrimaryURL: string = environment.apiUrl;
    constructor(private http: HttpClient) { }

    private getOptions(headers?: any): any {
        return {
            headers: new HttpHeaders(headers)
        };
    }

    private handleError(error: any): Observable<never> {
        console.error('An error occurred:', error);
        return throwError(error);
    }

    get(endpoint: string, params?: any, optionsAdd?: any): Observable<any> {
        let options = this.getOptions(optionsAdd);
        let httpParams = new HttpParams();
        if (params) {
            for (let key in params) {
                if (params.hasOwnProperty(key)) {
                    httpParams = httpParams.set(key, params[key]);
                }
            }
        }

        return this.http.get<any>(`${this.PrimaryURL}${endpoint}`, { ...options, params: httpParams });
    }


    download(endpoint: string, params?: any, optionsAdd?: any): Observable<any> {
        let options = this.getOptions(optionsAdd);
        let httpParams = new HttpParams();
        if (params) {
            for (let key in params) {
                if (params.hasOwnProperty(key)) {
                    httpParams = httpParams.set(key, params[key]);
                }
            }
        }

        return this.http.get<any>(`${this.PrimaryURL}${endpoint}`, {
            ...options,
            params: httpParams,
            responseType: 'blob'
        });
    }
    downloadPost(endpoint: string, body?: any, optionsAdd?: any): Observable<any> {
        let options = this.getOptions(optionsAdd);

        return this.http.post<any>(`${this.PrimaryURL}${endpoint}`, body, {
            ...options, responseType: 'blob'
        });
    }
    post(endpoint: string, body: any, optionsAdd?: any): Observable<any> {
        
        let options = this.getOptions();
        return this.http.post<any>(`${this.PrimaryURL}${endpoint}`, body, options);
    }

    post_string(endpoint: string, body: any, optionsAdd?: any): Observable<any> {
        let options = {
            headers: new HttpHeaders(
                {
                    // 'Content-Type': ' application/json; charset=utf-8',
                    'Accept': '*/*',
                    'content-type': 'application/json',
                }
            )
        };
        return this.http.post<any>(`${this.PrimaryURL}${endpoint}`, JSON.stringify(body), options);
    }

    put(endpoint: string, body: any): Observable<any> {
        let options = this.getOptions();
        return this.http.put<any>(`${this.PrimaryURL}${endpoint}`, body, options).pipe(
            catchError(this.handleError)
        );
    }

    patch(endpoint: string, body: any): Observable<any> {
        let options = this.getOptions();
        return this.http.patch<any>(`${this.PrimaryURL}${endpoint}`, body, options).pipe(
            catchError(this.handleError)
        );
    }


    delete(endpoint: string, params?: any): Observable<any> {
        let options = {};//this.getOptions();
        let httpParams = new HttpParams();
        if (params) {
            for (let key in params) {
                if (params.hasOwnProperty(key)) {
                    httpParams = httpParams.set(key, params[key]);
                }
            }
        }

        return this.http.delete<any>(`${this.PrimaryURL}${endpoint}`, { ...options, params: httpParams }).pipe(
            catchError(this.handleError)
        );
    }
}


